import React, { useEffect, useState } from 'react';
import Typeahead from '../../../CommonElements/TypeAhead';
import { getClientUrlDataToken } from '../../../Utils/restUtils';
import { getCustomers, getCustomersRole } from '../../../CommonUrl';

const CustomerFilter = ({ authState, onCustomerChange, handleApiError, selectedCustomer,currentCustomer, setCurrentCustomer }) => {
    const [customerOptions, setCustomerOptions] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);

    useEffect(() => {
        fetchCustomerData();

    }, []);

    const fetchCustomerData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
        if (data.status === true) {
            const options = data.data.map((customer) => ({
                value: customer.id,
                label: customer.name,
            }));
            setCustomerOptions(options);
            setFilteredOptions(options);
            if (selectedCustomer) {
                const selected = options?.find(item => String(item.value) === String(selectedCustomer));
                setCurrentCustomer(selected)
            }
        } else {
            handleApiError(data.status);
        }
    };

    const handleInputChange = (value) => {
        const filtered = customerOptions.filter((option) =>
            option.label.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredOptions(filtered);
    };

    return (
        <Typeahead
            value={currentCustomer}
            options={filteredOptions}
            onChange={onCustomerChange}
            onInputChange={handleInputChange}
            placeholder="Customer..."
            isClearable
        />
    );
};


export default CustomerFilter;